<template>
  <div class="login-wrapper" @mousemove="handleGlobalMouseMove">
    <div class="svg-background">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">

      </svg>
    </div>

    <div class="login-container">

      <transition name="el-zoom-in-center" appear>
        <div
            class="login-card-3d-wrapper"
            ref="cardWrapper"
            :style="card3DStyle"
            @mousemove="handleCardMouseMove"
            @mouseleave="resetCard"
        >
          <el-card class="login-card-glass" shadow="never">
            <div class="login-header">

              <h2>DEECOO CRM</h2>
              <p class="subtitle">智能·连接·增长</p>
            </div>

            <el-form :model="form" ref="form" :rules="rules" size="large">
              <el-form-item prop="username" class="interactive-item">
                <el-input
                    v-model="form.username"
                    placeholder="请输入业务账号"
                    prefix-icon="el-icon-user"
                    clearable
                ></el-input>
                <div class="input-glow"></div>
              </el-form-item>

              <el-form-item prop="password" class="interactive-item">
                <el-input
                    v-model="form.password"
                    type="password"
                    placeholder="请输入安全密码"
                    show-password
                    prefix-icon="el-icon-lock"
                    @focus="handlePasswordFocus"
                    @blur="handlePasswordBlur"
                    @keyup.enter.native="login"
                ></el-input>
                <div class="input-glow"></div>
              </el-form-item>

              <el-form-item class="submit-item">
                <el-button
                    type="primary"
                    @click="login"
                    :loading="loading"
                    class="energy-btn"
                    :class="{ 'is-loading': loading }"
                >
                  <span v-if="!loading">登录</span>
                  <span v-else>正在构建连接...</span>
                  <div class="btn-energy-flow"></div>
                </el-button>
              </el-form-item>
            </el-form>

            <div class="tips-container">
              <div class="divider">
                <span class="divider-text">
                  <i class="el-icon-key"></i> 安全凭证
                </span>
              </div>
              <p><span class="highlight">{{LoginMessage}}</span></p>
            </div>
          </el-card>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      LoginMessage:'初始密码:123456',
      // 3D 卡片状态
      cardTransform: { x: 0, y: 0, glossX: 50, glossY: 50 },
      // 眼睛状态
      irisTransform: { x: 0, y: 0 },
      isPasswordFocused: false
    }
  },
  computed: {
    // 3D 卡片样式
    card3DStyle() {
      const { x, y, glossX, glossY } = this.cardTransform;
      return {
        transform: `perspective(1000px) rotateX(${x}deg) rotateY(${y}deg)`,
        '--gloss-x': `${glossX}%`,
        '--gloss-y': `${glossY}%`
      };
    },
    // 眼睛盯鼠标样式
    irisStyle() {
      return {
        transform: `translate(${this.irisTransform.x}px, ${this.irisTransform.y}px)`
      };
    }
  },
  methods: {
    // 1. 全局鼠标移动 (用于眼睛盯鼠标)
    handleGlobalMouseMove(e) {
      if (this.isPasswordFocused) return; // 捂眼睛时不盯鼠标

      const mouseX = e.clientX;
      const mouseY = e.clientY;

      // 动态计算怪兽眼睛的中心点
      const eyesCenterX = window.innerWidth / 2;
      const eyesCenterY = window.innerHeight / 2 - 180; // 根据怪兽位置调整

      const angle = Math.atan2(mouseY - eyesCenterY, mouseX - eyesCenterX);

      // 眼睛移动的最大半径 (像素)
      const maxDistance = 10;

      this.irisTransform = {
        x: Math.cos(angle) * maxDistance,
        y: Math.sin(angle) * maxDistance
      };
    },

    // 2. 卡片鼠标移动 (用于 3D 效果, 保持之前逻辑)
    handleCardMouseMove(e) {
      if (!this.$refs.cardWrapper) return;
      const card = this.$refs.cardWrapper;
      const rect = card.getBoundingClientRect();
      const cardCenterX = rect.left + rect.width / 2;
      const cardCenterY = rect.top + rect.height / 2;

      const rotateX = -((e.clientY - cardCenterY) / (rect.height / 2)) * 6;
      const rotateY = ((e.clientX - cardCenterX) / (rect.width / 2)) * 6;

      const glossX = ((e.clientX - rect.left) / rect.width) * 100;
      const glossY = ((e.clientY - rect.top) / rect.height) * 100;

      this.cardTransform = { x: rotateX, y: rotateY, glossX, glossY };
    },

    resetCard() {
      this.cardTransform = { x: 0, y: 0, glossX: 50, glossY: 50 };
    },

    // 3. 密码框交互 (触发捂眼睛动画)
    handlePasswordFocus() {
      this.isPasswordFocused = true;
      this.irisTransform = { x: 0, y: 0 }; // 捂眼睛时眼睛归位
    },
    handlePasswordBlur() {
      this.isPasswordFocused = false;
    },

    // 登录逻辑 (保持之前)
    async login() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$request.postHttp({
          url: '/api/auth/login',
          data: this.form,
          success: (data) => {
            if (data.data.success) {
              localStorage.setItem('isLoggedIn', 'true');
              localStorage.setItem('token', data.data.token || 'fake-token');
              localStorage.setItem('user', data.data.username || this.form.username)
              localStorage.setItem('istop', data.data.istop)

              this.$message.success('登录成功，正在加载权限...');
              setTimeout(() => {
                this.$router.push('/');
              }, 200);
            } else {
              this.LoginMessage=data.data.message || '凭证验证失败'
              this.loading = false
            }
          },
          error: () =>  this.LoginMessage='数据网络连接异常',
          finally: () => this.loading = false
        });
      });
    }
  }
}
</script>

<style scoped>
/* ==================== 1. 基础布局与浅橙黄色系背景 ==================== */
.login-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  /* 换成浅橙黄渐变 */
  background: radial-gradient(circle at center, #fff3e0 0%, #ffe0b2 100%);
  overflow: hidden;
  perspective: 1000px; /* 3D透视 */
}

/* 动态网格背景 */
.svg-background {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  z-index: 1; opacity: 0.8;
  animation: backgroundPan 30s linear infinite;
}

@keyframes backgroundPan {
  0% { transform: scale(1.1) translateY(0); }
  50% { transform: scale(1.1) translateY(-3%); }
  100% { transform: scale(1.1) translateY(0); }
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  position: relative;
  top: -40px; /* 整体上移一点 */
}

/* ==================== 2. 怪兽交互区域 CSS (更换主体颜色) ==================== */
.monster-wrapper {
  width: 300px;
  height: 130px; /* 适当减小高度 */
  margin-bottom: -25px; /* 负边距，让怪兽趴在卡片上 */
  position: relative;
  z-index: 1; /* 在卡片后面 */
  transition: all 0.3s ease;
}

.monster-svg {
  width: 100%; height: 100%;
  overflow: visible; /* 允许手臂移动出 viewBox */
}

/* 眼睛虹膜 Transition */
.iris {
  transition: transform 0.1s ease-out; /* 盯鼠标需要平滑快速 */
  will-change: transform;
}

/* 手臂 Transition (带有弹性的核心动画) */
.arm {
  transition: all 0.45s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  transform-origin: bottom;
  will-change: transform, d, stroke;
}

/* ==================== 捂眼睛时的状态控制 ==================== */
/* 当 .monster-wrapper 拥有 .is-covering 类时触发 */

/* 左臂移动到左眼 */
.is-covering .left-arm {
  transform: translate(40px, -60px) rotate(-15deg);
  /* 手臂捂眼睛时变色高亮为深橙色 */
  stroke: #F57C00;
}

/* 右臂移动到右眼 */
.is-covering .right-arm {
  transform: translate(-40px, -60px) rotate(15deg);
  stroke: #F57C00;
}

/* 捂眼睛时眼睛稍微闭上一点 */
.is-covering .iris {
  transform: scaleY(0.1) !important;
}

/* ==================== 3. 3D 玻璃拟态卡片 (保持之前的酷炫感) ==================== */
.login-card-3d-wrapper {
  transition: transform 0.1s ease-out;
  will-change: transform;
  position: relative;
  z-index: 2; /* 在怪兽前面 */
}

/* 卡片表面的流动光泽 */
.login-card-3d-wrapper::before {
  content: '';
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  border-radius: 20px;
  /* 浅色背景下光泽用白色更明显 */
  background: radial-gradient(circle at var(--gloss-x) var(--gloss-y), rgba(255, 255, 255, 0.5) 0%, transparent 50%);
  z-index: 3; pointer-events: none;
}

.login-card-glass {
  width: 420px;
  /* 浅色玻璃拟态 */
  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  /* 橙色边框 */
  border: 2px solid rgba(255, 152, 0, 0.2);
  border-radius: 20px;
  /* 更柔和的橙色阴影 */
  box-shadow: 0 25px 50px rgba(245, 124, 0, 0.15);
}

/* ==================== 4. 品牌头部区域 ==================== */
.login-header {
  text-align: center;
  margin-bottom: 35px;
}

.logo-area {
  position: relative;
  width: 55px; height: 55px;
  margin: 0 auto 12px;
}

.logo-icon {
  width: 100%; height: 100%;
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  color: #fff;
  border-radius: 14px;
  line-height: 55px;
  font-size: 30px;
  font-weight: bold;
  box-shadow: 0 4px 15px rgba(245, 124, 0, 0.4);
  position: relative; z-index: 2;
}

/* Logo 扫光动画 */
.logo-shimmer {
  position: absolute;
  top: -50%; left: -50%; width: 200%; height: 200%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  transform: rotate(30deg);
  animation: logoShimmer 5s infinite;
  z-index: 3;
}

@keyframes logoShimmer {
  0% { transform: translateX(-100%) rotate(30deg); }
  15%, 100% { transform: translateX(100%) rotate(30deg); }
}

h2 {
  color: #303133; /* 浅色背景用深色标题 */
  margin: 0;
  font-size: 24px;
  letter-spacing: 1.5px;
  font-weight: 600;
}

.subtitle {
  color: #909399;
  font-size: 13px;
  margin-top: 5px;
}

/* ==================== 5. 互动输入框 (Vue 2 深度选择器) ==================== */
.interactive-item {
  margin-bottom: 25px !important;
  position: relative;
}

.login-card-glass >>> .el-input__inner {
  background-color: rgba(255, 255, 255, 0.7) !important;
  border-radius: 10px;
  border: 1px solid #dcdfe6;
  color: #303133 !important;
  height: 48px;
  transition: all 0.3s;
}

/* 输入框聚焦时的橙色高亮 */
.login-card-glass >>> .el-input__inner:focus {
  border-color: #FF9800;
  box-shadow: 0 0 10px rgba(255, 152, 0, 0.15);
}

.login-card-glass >>> .el-input__prefix {
  font-size: 18px;
  color: rgba(255, 152, 0, 0.6);
}

/* 聚焦时的光晕效果 */
.input-glow {
  position: absolute;
  bottom: 0; left: 50%;
  width: 0; height: 2px;
  background: #FF9800;
  box-shadow: 0 0 8px #FF9800;
  transition: all 0.4s ease;
  transform: translateX(-50%);
  z-index: 2; pointer-events: none;
}

.login-card-glass >>> .el-input__inner:focus ~ .input-glow {
  width: 100%;
}

/* ==================== 6. 橙色能量按钮 ==================== */
.energy-btn {
  width: 100%; height: 50px;
  background: linear-gradient(135deg, #FFB74D 0%, #F57C00 100%);
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
  box-shadow: 0 5px 15px rgba(245, 124, 0, 0.3);
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.energy-btn:hover:not(.is-loading) {
  transform: scale(1.02) translateY(-2px);
  box-shadow: 0 8px 20px rgba(245, 124, 0, 0.5);
}

.energy-btn:active:not(.is-loading) {
  transform: scale(0.98);
}

/* 按钮内部的能量流动动画 (加载时) */
.btn-energy-flow {
  position: absolute;
  top: 0; left: -100%;
  width: 100%; height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  z-index: 1;
}

.energy-btn.is-loading .btn-energy-flow {
  animation: energyFlow 1.5s infinite;
}

@keyframes energyFlow {
  0% { left: -100%; }
  100% { left: 100%; }
}

/* ==================== 7. 底部提示区域 ==================== */
.tips-container {
  margin-top: 25px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.divider {
  border-top: 1px solid #e0e0e0;
  margin: 18px 0;
  position: relative;
}

.divider-text {
  position: absolute;
  top: -11px; left: 50%;
  transform: translateX(-50%);
  background: #fff8f0; /* 匹配背景色，截断线条 */
  padding: 0 15px;
  color: rgba(0, 0, 0, 0.3);
  font-size: 12px;
}

.highlight {
  color: #F57C00;
  font-weight: bold;
}
</style>